import { useQuery } from "@tanstack/react-query";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import type { GetLiveness200 } from "../../generated/core-api";

// No generated React Query hook exists for the liveness endpoint, so we use a
// manual TanStack Query call with the generated response type.
export function useApiVersion(): string | undefined {
  const { data } = useQuery({
    queryKey: ["api-version"],
    queryFn: async () => {
      const instance = await getCoreAxiosInstance();
      const { data } = await instance.get<GetLiveness200>(
        "/api/v1/health/live",
      );
      return data.version;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return data ?? undefined;
}
